import type { TrainingLossSeries } from '@/api/generated/model'

export interface LossPoint {
  step: number
  loss: number | null
  evalLoss: number | null
}

/**
 * One chart row per measured step, oldest first. Training loss is measured
 * every optimizer step and evaluation loss only at some, so a row carries
 * null for the series that was not measured there (never an interpolation).
 */
export function lossPoints(
  loss: TrainingLossSeries | null,
  evalLoss: TrainingLossSeries | null,
): LossPoint[] {
  const points = new Map<number, LossPoint>()
  function add(series: TrainingLossSeries | null, key: 'loss' | 'evalLoss'): void {
    if (series === null) return
    series.series.forEach((value, index) => {
      const step = series.steps[index]
      if (step === undefined) throw new Error('Loss observation is missing its step')
      const point = points.get(step) ?? { step, loss: null, evalLoss: null }
      point[key] = value
      points.set(step, point)
    })
  }
  add(loss, 'loss')
  add(evalLoss, 'evalLoss')
  return [...points.values()].sort((left, right) => left.step - right.step)
}
